export const environment = {
  production: true,
  env: 'Ambiente Produccion',
  apiUrl: 'https://gmemaapi.clavisco.com/',
  reportManagerUrl: 'https://gmrpmapi.clavisco.com/',
  padronUrl: 'https://api.hacienda.go.cr/fe/'
};
